import { FC, memo } from 'react';
import cx from 'clsx';

import { useDownloadMedia, useShareMedia } from 'src/hooks';

import { Icon } from 'src/components/Icon';

import styles from './styles.module.css';
import { FileType } from 'src/types';

type Props = {
  file?: FileType;
};

export const BottomBar: FC<Props> = memo(({ file }) => {
  const { download } = useDownloadMedia();
  const { share } = useShareMedia();

  if (!file) {
    return null;
  }

  return (
    <div className={styles.bottomBar}>
      <button
        name="download"
        className={styles.button}
        type="button"
        onClick={() => download()}
      >
        <Icon
          className={cx(styles.icon, styles.iconDownload)}
          name="download"
        />
      </button>
      <button
        name="share"
        className={styles.button}
        type="button"
        onClick={() => share()}
      >
        <Icon className={cx(styles.icon, styles.iconShare)} name="share" />
      </button>
    </div>
  );
});
